import { Avatar, Box, CardHeader, IconButton, Typography } from '@mui/material';
import Email from '@mui/icons-material/Email';
import Phone from '@mui/icons-material/Phone';
import { CandidateLink } from 'domain/shared/candidate';
import { RejectPeopleIcon, Tooltip } from 'framework/ui/mui-builder';
import { EMPTY_VALUE_INDICATOR } from 'framework/utils';

const renderValue = <T,>(value: T) => value ?? EMPTY_VALUE_INDICATOR;

interface ICandidateCardProps {
  candidatePhoto?: string;
  candidate: any;
  showVacancyRejectButton?: boolean;
  showVacancyReject?: boolean;
  togleVacancyReject?: () => void;
}

const CandidateCard: React.FC<ICandidateCardProps> = ({
  candidatePhoto,
  candidate,
  showVacancyRejectButton,
  showVacancyReject,
  togleVacancyReject,
}) => {
  return (
    <CardHeader
      sx={{ p: 1, '& .MuiCardHeader-avatar': { mr: 1 }, alignItems: 'flex-start' }}
      avatar={
        <Avatar
          src={candidatePhoto}
          alt="Candidate"
          sx={{
            mt: '10px',
            width: 75,
            height: 75,
            borderRadius: '50%',
          }}
        />
      }
      title={
        <Box display="flex" alignItems="baseline" flexDirection="column">
          <Box display="flex" justifyContent="space-between" width="100%" alignItems="baseline" gap={1}>
            {candidate?.id ? (
              <CandidateLink
                id={candidate?.id}
                name={renderValue(`${candidate?.name?.firstName ?? ''} ${candidate?.name?.lastName ?? ''}`)}
              />
            ) : (
              <Typography variant="body1" color="primary">
                {renderValue(`${candidate?.name?.firstName ?? ''} ${candidate?.name?.lastName ?? ''}`)}
              </Typography>
            )}

            <Box>
              <Typography variant="body1" color="textSecondary">
                <IconButton>
                  <Email />
                </IconButton>
                {renderValue(candidate?.personalEmail)}
              </Typography>
              <Typography variant="body1" color="textSecondary">
                <IconButton>
                  <Phone />
                </IconButton>
                {renderValue(candidate?.personalPhoneNumber)}
              </Typography>
            </Box>
          </Box>

          <Box display="flex" width="100%" justifyContent="flex-end" height="35px">
            {showVacancyRejectButton ? (
              <Tooltip title="Сandidate's refusal">
                <IconButton sx={{ p: '6px' }} onClick={togleVacancyReject}>
                  <RejectPeopleIcon sx={{ color: showVacancyReject ? 'text.secondary' : 'error.main' }} />
                </IconButton>
              </Tooltip>
            ) : null}
          </Box>
        </Box>
      }
    />
  );
};

export default CandidateCard;
